import { Operation } from "@/backend/models/operation";
import { ParameterLink } from "@/frontend/components/parameters/ParameterLink";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { I18n } from "@/i18n/I18n";
import { ParameterSubjectType } from "@/types/parameterTypes";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useShallow } from "zustand/react/shallow";
import { ParameterValue } from "../parameters/ParameterItem";

export function FieldItem(props: { operation: Operation }) {
  const { operation } = props;
  const [parameter] = useParameterStore(useShallow((state) => state.parametersForSubject(operation.id, ParameterSubjectType.OPERATION)));
  const onChangeContent = useTreeStore(state => state.updateOperation);
  const [content, setContent] = useState(operation.content);

  useEffect(() => {
    setContent(operation.content);
  }, [operation.content]);

  return (
    <>
      <Form.Label className="col-form-label col-form-label-sm">{operation.isFieldType() ? I18n.get('name') : I18n.get('description')}</Form.Label>
      <Form.Control 
        size='sm'
        value={content} 
        onChange={(e) => setContent(e.target.value)} 
        onBlur={() => void onChangeContent({ operation: { ...operation, content } })} 
        as={operation.isFieldType() ? 'input' : 'textarea'}
      />
      <ParameterValue parameter={parameter} />
      <table>
        <tbody>
          <ParameterLink parameter={parameter} operation={operation} />
        </tbody>
      </table>
    </>
  );
}
